export default "__VITE_ASSET__Corl_IS2__"